import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  min-height: 5rem;\n  background: ", ";\n  box-shadow: ", ";\n  border-radius: ", ";\n\n  & > * {\n    padding: ", ";\n  }\n\n  & > :first-child {\n    border-top-width: 1px;\n    border-top-left-radius: ", ";\n    border-top-right-radius: ", ";\n  }\n\n  & > :last-child {\n    border-bottom-width: 1px;\n    border-bottom-left-radius: ", ";\n    border-bottom-right-radius: ", ";\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import React from 'react';
import styled from 'styled-components';
var Wrapper = styled.div(_templateObject(), function (p) {
  return p.theme.relativeWhite;
}, function (p) {
  return p.theme.shadowSmallest;
}, function (p) {
  return p.theme.borderRadius;
}, function (p) {
  return p.theme.fontSizeDisplayMedium;
}, function (p) {
  return p.theme.borderRadius;
}, function (p) {
  return p.theme.borderRadius;
}, function (p) {
  return p.theme.borderRadius;
}, function (p) {
  return p.theme.borderRadius;
});

var Card = function Card(_ref) {
  var _ref$children = _ref.children,
      children = _ref$children === void 0 ? null : _ref$children;
  return /*#__PURE__*/React.createElement(Wrapper, null, children);
};

export default Card;